import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import DemoWizardItem from '../../../Domain/DemoWizardItem';

export default class DemoWizardWindowDescription {
  static titleForCreate = 'Add Demo Item';
  static titleForEdit = 'Edit Demo Item';
  static entityName = 'Demo Item';
  static itemType = DemoWizardItem;
  static messageOnSuccess = 'Demo item "saved" (in-memory only — nothing was sent to the backend).';
  static finishButtonLabel = 'Finish';

  static serviceFunction = (edited: DemoWizardItem) => Promise.resolve({});

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name *',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CategoryId',
          label: 'Category *',
          className: 'col-6',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.forRequiredSelectField,
          selectvalues: [
            { label: '-- Select --', value: '' },
            { label: 'Retail', value: 1 },
            { label: 'Hospitality', value: 2 },
            { label: 'Automotive', value: 3 },
          ],
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          numberOfRows: 3,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
    {
      label: 'Details',
      fields: [
        {
          fieldName: 'StartDate',
          label: 'Start Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Budget',
          label: 'Budget',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
